import videojs from "video.js";
import "video.js/dist/video-js.css";
// import "videojs-youtube";
import "videojs-contrib-ads";
import "videojs-ima";

window.videojs = window.videojs || videojs;

export default videojs;